export const handleScrollToField = (id: string) => {
  if (!id) return;
  const foundEl = document.getElementById(id);
  if (!foundEl) return;

  foundEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
